import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductDimensions extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDimensions);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDimensions);
  }

  /**
   * Updates the dimensions.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDimensions = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDimensions = event.detail.data.html.querySelector('product-dimensions');

    if (!newDimensions) return;

    morph(this, newDimensions, { childrenOnly: true });
  };
}

if (!customElements.get('product-dimensions')) {
  customElements.define('product-dimensions', ProductDimensions);
}
